import React from 'react';
import { useProCalculator } from '../hooks/useProCalculator';
import SectionHelp from './SectionHelp';
import UnitToggle from './UnitToggle';
import '../styles/SetsSection.css';

const SetsSection = () => {
  const {
    useSets,
    setUseSets,
    setRows,
    updateSetRow,
    addSetRow,
    removeSetRow,
    cookieRows,
    isMobile,
    goToNextSection,
    activeSection
  } = useProCalculator();

  return (
    <div className="sets-section">
      {/* Header with title only */}
      <div className="section-header">
        <h2 className="section-title">Cookie Sets</h2>
      </div>

      {/* Help text container */}
      <div className="section-help-container">
        <SectionHelp sectionId="sets" isMobile={isMobile} />
      </div>
      
      <div className="sets-toggle-container">
        <label className="sets-toggle-label"> 
          Use Cookie Sets
        </label>
        <UnitToggle
          checked={useSets}
          onChange={setUseSets}
          leftLabel="Off"
          rightLabel="On"
        />
      </div>
      
      {useSets && (
        <div className="sets-table">
          <div className="sets-table-header">
            <div className="set-name-header">Set Name</div>
            <div className="cookie-name-header">Cookie</div>
            <div className="count-header">Count</div>
            <div className="actions-header">Actions</div>
          </div>
          
          {setRows.map(row => (
            <div key={row.id} className="set-row">
              <div className="set-name-field">
                <input
                  type="text"
                  value={row.setName}
                  onChange={(e) => updateSetRow(row.id, 'setName', e.target.value)}
                  className="set-name-input"
                />
              </div>
              
              <div className="cookie-name-field">
                <select
                  value={row.cookieId}
                  onChange={(e) => updateSetRow(row.id, 'cookieId', e.target.value)}
                  className="cookie-name-select"
                >
                  <option value="">Select a cookie</option>
                  {cookieRows
                    .filter(cookieRow => cookieRow.cookieName !== 'Cookie Name')
                    .map(cookieRow => (
                      <option key={cookieRow.id} value={cookieRow.cookieId}>
                        {cookieRow.cookieName}
                      </option>
                    ))
                  }
                </select>
              </div>
              
              <div className="count-field">
                <input
                  type="number"
                  min="1"
                  max="99"
                  value={row.count}
                  onChange={(e) => {
                    const value = Math.min(99, Math.max(1, parseInt(e.target.value) || 1));
                    updateSetRow(row.id, 'count', value);
                  }}
                  className="count-input"
                />
              </div>
              
              <div className="actions-field">
                <button 
                  onClick={() => removeSetRow(row.id)} 
                  className="remove-row-button" 
                  title="Remove Row"
                >
                  <span className="minus-icon">-</span>
                </button>
                <button 
                  onClick={() => addSetRow(row.setName)} 
                  className="add-row-button" 
                  title="Add Row"
                >
                  <span className="plus-icon">+</span>
                </button>
              </div>
            </div>
          ))}
          
          {setRows.length === 0 && (
            <div className="set-row">
              <div className="set-name-field">
                <input
                  type="text"
                  defaultValue="Set 1"
                  onChange={(e) => updateSetRow(1, 'setName', e.target.value)}
                  className="set-name-input"
                />
              </div>
              
              <div className="cookie-name-field">
                <select
                  defaultValue=""
                  onChange={(e) => updateSetRow(1, 'cookieId', e.target.value)}
                  className="cookie-name-select"
                >
                  <option value="">Select a cookie</option>
                  {cookieRows
                    .filter(cookieRow => cookieRow.cookieName !== 'Cookie Name')
                    .map(cookieRow => (
                      <option key={cookieRow.id} value={cookieRow.cookieId}>
                        {cookieRow.cookieName}
                      </option>
                    ))
                  }
                </select>
              </div>
              
              <div className="count-field">
                <input
                  type="number"
                  min="1"
                  max="99"
                  defaultValue="1"
                  onChange={(e) => {
                    const value = Math.min(99, Math.max(1, parseInt(e.target.value) || 1));
                    updateSetRow(1, 'count', value);
                  }}
                  className="count-input"
                />
              </div>
              
              <div className="actions-field">
                <button 
                  onClick={() => addSetRow('Set 1')} 
                  className="add-row-button" 
                  title="Add Row"
                >
                  <span className="plus-icon">+</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* Next section button */}
      {activeSection !== 'all' && (
        <button
          className="next-section-button"
          onClick={() => goToNextSection('sets')}
        >
          Next: Dimensions
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14"></path>
            <path d="M12 5l7 7-7 7"></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default SetsSection;
